import { useMemo } from 'react';
import { Link, useParams } from 'react-router';
import { Menu } from 'antd';

import useNavigationKeyManager from 'hooks/useNavigationKeyManager';

const ApplicationMenu = () => {
  const { applicationId } = useParams();
  const url = `/applications/${applicationId}`;

  const fraudNavigation = useMemo(() => {
    const children = [
      {
        key: 'fraudCases',
        path: `${url}/fraud-cases`,
        exact: 'true',
        label: <Link to={`${url}/fraud-cases`}>Fraud Cases</Link>,
      },
      {
        key: 'efaCallVerification',
        path: `${url}/efa-call-verification`,
        exact: 'true',
        label: (
          <Link to={`${url}/efa-call-verification`}>EFA Call Verification</Link>
        ),
      },
      {
        key: 'efaContactPull',
        path: `${url}/efa-contact-pull`,
        exact: 'true',
        label: <Link to={`${url}/efa-contact-pull`}>EFA Contact Pull</Link>,
      },
      {
        key: 'poiVerification',
        path: `${url}/poi-verification`,
        exact: 'true',
        label: <Link to={`${url}/poi-verification`}>POI Verification</Link>,
      },
      {
        key: 'ofacReview',
        path: `${url}/ofac-review`,
        exact: 'true',
        label: <Link to={`${url}/ofac-review`}>OFAC Review</Link>,
      },
    ];

    return {
      key: 'fraud',
      label: 'Fraud',
      onTitleClick: ({ key }) => {
        toggleOpenKey(key);
      },
      children,
    };
  }, []);

  const navigationItems = [
    {
      key: 'accounts-overview',
      path: `${url}/application-overview`,
      exact: 'true',
      label: (
        <Link to={`${url}/application-overview`}>Application Overview</Link>
      ),
    },
    {
      key: 'attachments',
      path: `${url}/attachments`,
      exact: 'true',
      label: <Link to={`${url}/attachments`}>Attachments</Link>,
    },
    fraudNavigation,
  ];

  const [activeRouteKey, openKeys, toggleOpenKey] =
    useNavigationKeyManager(navigationItems);

  return (
    <Menu
      mode="inline"
      openKeys={openKeys}
      selectedKeys={activeRouteKey}
      items={navigationItems}
    ></Menu>
  );
};

export default ApplicationMenu;
